import React, { useMemo } from 'react';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { tipoDatoSchema } from '../../services/validators';

export default function TiposDato() {
    const keyField = 'id';
    const initForm = () => ({
        nombre: '',
        descripcion: ''
    });

    const tiposDatoEndpoints = useMemo(() => ({
        listar: ENDPOINTS.encuestasTiposDatos.listar,
        crear: ENDPOINTS.encuestasTiposDatos.crear,
        actualizar: ENDPOINTS.encuestasTiposDatos.actualizar,
        borrar: ENDPOINTS.encuestasTiposDatos.borrar
    }), []);

    const columns = [
        { label: 'No', key: 'index', align: 'center', render: (_, i) => i + 1 },
        { label: 'Nombre', key: 'nombre', width: '30%' },
        { label: 'Descripción', key: 'descripcion', as: 'textarea', width: '70%' }
    ];

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(tiposDatoEndpoints, { keyField, initForm, columns, schema: tipoDatoSchema });
    console.log('Data:', data);

    if (loading) return <Loading mensaje="Cargando Tipos de Datos..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Tipos de Datos"
                data={data}
                columns={columns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                disableDelete={item => item.registros_preguntas > 0}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Tipo de Dato"
                columns={columns}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
